import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'list',
            component: () => import(/* webpackChunkName: "list" */ '@/views/List'),
            meta: {
                title: '特例品',
                keepAlive: true
            }
        },
        {
            path: '/detail/:xcSpecNo',
            name: 'detail',
            component: () => import(/* webpackChunkName: "detail" */ '@/views/Detail'),
            meta: {
                title: 'noshow'
            }
        },
        {
            path: '/comment',
            name: 'comment',
            component: () => import(/* webpackChunkName: "comment" */ '@/views/Comment'),
            meta: {
                title: '商品评价'
            }
        },
        {
            path: '/order',
            name: 'order',
            component: () => import(/* webpackChunkName: "order" */ '@/views/ConfirmOrder'),
            meta: {
                title: '结算中心'
            }
        },
        {
            path: '/explaine',
            name: 'explaine',
            component: () => import(/* webpackChunkName: "explaine" */ '@/views/explain'),
            meta: {
                title: '发票说明'
            }
        },
        {
            path: '/address',
            name: 'address',
            component: () => import(/* webpackChunkName: "address" */ '@/views/Address'),
            meta: {
                title: '地址列表'
            }
        },
        {
            path: '/editAddress',
            name: 'editAddress',
            component: () => import(/* webpackChunkName: "editAddress" */ '@/views/EditAddress'),
            meta: {
                title: '地址列表'
            }
        }
        // {
        //     path: '/search',
        //     name: 'search',
        //     component: () => import(/* webpackChunkName: "search" */ '@/views/search'),
        //     meta: {
        //         title: '搜索'
        //     }
        // }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})
